<template>
  <div class="row">
    <div class="col-12 col-lg-6">
      <basic-portlet title="Useful Links" :no-shadow="true" :no-gutters="true">
        <div>
          <button class="btn btn-ss mr-2 mb-2" @click="copyPlayerLinkToClipboard(podcast)">
            <span>
              <i class="la la-copy" />
              <span>Copy Player Link</span>
            </span>
          </button>
          <button class="btn btn-ss mr-2 mb-2" @click="copyRSSToClipboard(podcast)">
            <span>
              <i class="la la-copy" />
              <span>Copy RSS Link</span>
            </span>
          </button>
          <button v-if="user.is_super_admin" class="btn btn-ss mr-2 mb-2" @click="copyPodcastWebsiteLinkToClipboard(entity)">
            <span>
              <i class="la la-copy" />
              <span>Copy Website Link</span>
            </span>
          </button>
        </div>
      </basic-portlet>
      <basic-portlet title="Share on Socials" :no-shadow="true" :no-gutters="true">
        <div>
          <button class="btn btn-ss mr-2 mb-2" @click="shareOnFacebook(podcast)">
            <span>
              <i class="socicon-facebook" />
              <span>Share on Facebook</span>
            </span>
          </button>
          <button class="btn btn-ss mr-2 mb-2" @click="shareOnTwitter(podcast)">
            <span>
              <i class="socicon-twitter" />
              <span>Share on Twitter</span>
            </span>
          </button>
          <button class="btn btn-ss mr-2 mb-2" @click="shareOnWhatsapp(podcast)">
            <span>
              <i class="socicon-whatsapp" />
              <span>Share on WhatsApp</span>
            </span>
          </button>
        </div>
      </basic-portlet>
    </div>
    <div class="col-12 col-lg-6">
      <basic-portlet title="Player Preview" :no-shadow="true" :no-gutters="true">
        <div v-if="episodes && episodes.length">
          <player-iframe-preview :is-feed="true"
                                 :item="podcast"
                                 :show-listen-link="false"
                                 :show-embed-code="true"
                                 :full-width="true"
                                 :show-tools="true" />
        </div>
        <div v-else>
          <p>Your Podcast doesn't currently have an Episodes. Please add your first episode to enable the Player Preview.</p>
        </div>
      </basic-portlet>
    </div>
  </div>
</template>

<script>
import BasicPortlet from "VueComponents/BasicPortlet";
import SocialShareMixin from "VueMixins/SocialShareMixin";
import PlayerIframePreview from "VueComponents/PlayerIframePreview";
import { mapWritableState } from 'pinia';
import { usePodcastManageStore } from "VueStore/app/podcastManage";

export default {
  components: { BasicPortlet, PlayerIframePreview },
  mixins: [SocialShareMixin],
  data() {
    return {
      user: window.user,
    };
  },
  computed: {
    ...mapWritableState(usePodcastManageStore, ['podcast']),
    ...mapWritableState(usePodcastManageStore, ['episodes']),
    ...mapWritableState(usePodcastManageStore, ['podcast_website']),
    entity() {
      const the_podcast = { ...this.podcast };
      the_podcast.podcast_website = { ...this.podcast_website };
      return the_podcast;
    },
  },
};
</script>
